import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { AlertTriangle, Trash2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { mockEvents, mockDrafts } from '@/lib/mockData';

export function AdminDeleteModal() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  
  const event = mockEvents.find(e => e.id === eventId) || mockDrafts.find(d => d.id === eventId);
  const title = event?.title || 'this event';

  const handleDelete = () => {
    navigate(`/admin/events/${eventId}/delete/confirmed`);
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  return (
    <AdminLayout>
      <div className="p-8 flex items-center justify-center min-h-[calc(100vh-4rem)]">
        <Card className="bg-card border-border p-8 max-w-md w-full text-center">
          {/* Warning Icon */}
          <div className="w-16 h-16 rounded-full bg-destructive/20 flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">Delete Event?</h1>
          <p className="text-muted-foreground mb-6">
            Are you sure you want to delete <span className="text-white font-medium">&quot;{title}&quot;</span>? 
            This action cannot be undone.
          </p>

          {/* Warning details */}
          <Card className="bg-destructive/10 border-destructive/30 p-4 mb-6 text-left">
            <p className="text-sm text-destructive">This will permanently delete:</p>
            <ul className="text-sm text-muted-foreground mt-2 space-y-1">
              <li>• All event details and settings</li>
              <li>• Ticket configurations</li>
              <li>• Associated media files</li>
              <li>• Analytics and revenue data</li>
            </ul>
          </Card>

          {/* Actions */}
          <div className="flex gap-3">
            <Button 
              variant="outline" 
              className="flex-1 border-border"
              onClick={handleCancel}
            >
              <X className="w-4 h-4 mr-2" />
              Cancel
            </Button>
            <Button 
              className="flex-1 bg-destructive text-white hover:bg-destructive/90"
              onClick={handleDelete}
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Event
            </Button>
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}

export default AdminDeleteModal;
